import { DocumentRequestType } from 'api/Documents/Types/DocumentRequests'

interface IDocumentRequestObject {
  label: string
  value: DocumentRequestType
}

export const otherDocumentRequestTypeList: {
  poi: IDocumentRequestObject[]
  client: IDocumentRequestObject[]
} = {
  poi: [
    {
      label: 'Additional POA',
      value: DocumentRequestType.AdditionalProofOfAddress,
    },
    {
      label: 'POI and POA',
      value: DocumentRequestType.RequestPOIAndPOA,
    },
    {
      label: 'POI Nigeria – NIN slip provided.',
      value: DocumentRequestType.RequestPOINigeriaNINSlipProvided,
    },
    {
      label: 'POI Nigeria (all types)',
      value: DocumentRequestType.RequestPOINigeria,
    },
    {
      label: 'POI Nigeria – NIN slip provided (DoB Clarification) + Address clarification',
      value: DocumentRequestType.RequestPOINigeriaNINAddress,
    },
    {
      label: 'POI India (all types)',
      value: DocumentRequestType.RequestPOIIndia,
    },
    {
      label: 'POI Philippines (all types)',
      value: DocumentRequestType.RequestPOIPhillipines,
    },
    {
      label: '2nd page of HRD booklet',
      value: DocumentRequestType.AdditionalHRD,
    },
    {
      label: 'Back Side of POI and proper POA(type)',
      value: DocumentRequestType.BackSidePoiAndProperPOA,
    },
    {
      label: 'KYC update – Request POA',
      value: DocumentRequestType.KYCAdditionalPoa,
    },
    {
      label: 'Front Side of ID and address clarification',
      value: DocumentRequestType.FrontSidePoiAndAddressClarification,
    },
    {
      label: 'Back Side of ID and address clarification',
      value: DocumentRequestType.BackSidePoiAndAddress,
    },
    {
      label: 'Upload Renewed Passport',
      value: DocumentRequestType.AdditionalRenewedPassport,
    },
    {
      label: 'Upload Renewed ID',
      value: DocumentRequestType.AdditionalRenewedIdentity,
    },
    {
      label: 'Upload Renewed Driving License',
      value: DocumentRequestType.AdditionalRenewedDrivingLicense,
    },
    {
      label: 'Front Side of POI + POA',
      value: DocumentRequestType.FrontSidePoiAndPoa,
    },
    {
      label: 'Back Side of POI + POA',
      value: DocumentRequestType.BackSidePoiAndPOA,
    },
    {
      label: 'Address Clarification + POA',
      value: DocumentRequestType.AdditionalPoaAndAddressClarification,
    },
    {
      label: 'POI + Address Clarification',
      value: DocumentRequestType.AdditionalPoiAndAddressClarification,
    },
    {
      label: 'POI + POA in English',
      value: DocumentRequestType.AdditionalPoiAndPoaEnglish,
    },
    // {
    //   label: 'Request POA (China)',
    //   value: DocumentRequestType.ChinesePoa,
    // },
  ],
  client: [
    {
      label: 'Name clarification',
      value: DocumentRequestType.RequestNameClarification,
    },
    {
      label: 'Date of Birth Clarification',
      value: DocumentRequestType.RequestDateOfBirthClarification,
    },
    {
      label: 'TIN Request',
      value: DocumentRequestType.RequestTin,
    },
    {
      label: 'LEI Code Request (Corporate)',
      value: DocumentRequestType.AdditionalLeiCode,
    },
    {
      label: 'DSS Number Request (Greek)',
      value: DocumentRequestType.AdditionalDssNumber,
    },
  ],
}
